export function remapStringToTitleWithId(value: string): TitleWithId<string> {
  return {id: value, title: value}
}
